(function () {
    'use strict';

    let selectId = (id) => id.split('/')[id.split('/').length - 1];

    angular.module('doclr.resources.api', [])
        .factory('AgendaOverzicht', function ($http, AppConfigService, praktijkContext) {

            var appointmentFilter = {};

            var overzichtOperations = {
                findAgendaVoorId: function (id) {
                    return _.find(this, (agenda) => selectId(agenda.id) === selectId(id));
                }
            };

            function addAddressToCalendar(calendar) {
                if (calendar.partyAddressId && praktijkContext.adressen) {
                    const matchingAddressess = praktijkContext.adressen.filter(a => a.id === calendar.partyAddressId);
                    if (matchingAddressess.length > 0) {
                        calendar.partyAddress = matchingAddressess[0];
                        calendar.partyMultiLocation = praktijkContext.meerdereLocaties;
                    }
                }
            }

            var agendaOperations = {
                maakBeschikbaarheid: function (dag, van, tot, afspraakDuur, aantalAfspraken, availabilityReleaseStrategy, typeId, titel, reden) {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/' + dag + '/beschikbaarheid',
                        {
                            van: van,
                            tot: tot,
                            afspraakDuur: afspraakDuur,
                            aantalAfspraken: aantalAfspraken,
                            availabilityReleaseStrategy: availabilityReleaseStrategy,
                            typeId: typeId,
                            titel: titel,
                            reden: reden
                        }
                    );
                },
                maakNieuweAfspraak: function (allowConflict, afspraak) {
                    let url = AppConfigService.getApiUrl() + this.id + '/' + afspraak.dag + (allowConflict ? '/allow-conflict' : '');
                    return $http.post(url, afspraak);
                },
                maakAfwezigheid: function (multiCalendarSelection, interval, titel, reden) {
                    let createAvailabilityRequest = {
                        dagVan: interval.dagVan,
                        van: interval.uurVan,
                        dagTot: interval.dagTot,
                        tot: interval.uurTot,
                        heleDag: interval.heleDag,
                        titel: titel,
                        reden: reden
                    };

                    if (multiCalendarSelection) {
                        createAvailabilityRequest.forAllCalendars = multiCalendarSelection.forAllCalendars;
                        createAvailabilityRequest.calendarIds = multiCalendarSelection.calendarIds;
                    }


                    return $http.post(AppConfigService.getApiUrl() + this.id + '/afwezigheid',
                        createAvailabilityRequest
                    );
                },
                maakWerkschema: function (vanaf) {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/werkschema', {
                        vanaf: vanaf,
                        weken: [[]]
                    });
                }
            };

            return {
                get: function (praktijkId) {

                    let url = AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/agenda';

                    return $http({
                        method: 'GET',
                        url: url,
                        params: {relationId: appointmentFilter.relationId, duration: appointmentFilter.duration},
                    }).then(function (response) {
                        var result = _.map(response.data, function (agenda) {
                            addAddressToCalendar(agenda);
                            return angular.extend({}, agenda, agendaOperations);
                        });

                        return angular.extend(result, overzichtOperations);
                    });
                },
                setAppointmentType: function (relationId) {
                    appointmentFilter.relationId = relationId;
                },
                setDuration: function (duration) {
                    appointmentFilter.duration = duration;
                }
            };
        })
        .factory('ResourceOverzicht', function ($http, AppConfigService, praktijkContext) {

            let resourceUrl = AppConfigService.getApiUrl() + "/api/calendar/v1/party/" + praktijkContext.id + "/resource";

            var overzichtOperations = {
                findResourceVoorId: function (id) {
                    return _.find(this, (recource) => selectId(recource.id) === selectId(id));
                }
            };

            var resourceOperations = {
                maakAfwezigheid: function (multiCalendarSelection, interval, titel, reden) {
                    let reserveUrl = resourceUrl + "/" + selectId(this.id) + "/reserve";
                    return $http.post(reserveUrl,
                        {
                            fromDay: interval.dagVan,
                            untilDay: interval.dagTot,
                            fromHours: interval.uurVan,
                            untilHours: interval.uurTot,
                            wholeDay: interval.heleDag,
                            title: titel,
                            description: reden,
                        }
                    );
                }
            }

            return {
                get: function (praktijkId) {
                    let url = AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/resource';
                    return $http({
                        method: 'GET',
                        url: url,
                    }).then(function (response) {
                        var result = _.map(response.data, function (resource) {
                            return angular.extend({}, resource, resourceOperations);
                        });
                        return angular.extend(result, overzichtOperations);
                    });
                }
            };
        })

        .factory('Agendas', function ($http, AppConfigService, EventFactory) {
            var Agendas = {};

            var appointmentFilter = {};

            var createSlice = function (agenda, dag) {
                var slice = angular.extend({}, agenda, dag);

                slice.events = _.map(slice.events, function (event) {
                    return EventFactory.createEvent(event);
                });

                return slice;
            };

            var createSlices = function (response) {
                var result = [];
                angular.forEach(response.data, function (agenda) {
                    angular.forEach(agenda.dagen, function (dag) {
                        result.push(createSlice(agenda, dag));
                    });
                });

                return result;
            };

            var haalSlicesOp = function (url, van, tot, discipline, agendas, resources, uitgeslotenDagen, relationId, duration) {

                let agendaIds = null;
                if (agendas) {
                    agendaIds = agendas.map(x => selectId(x))
                }

                let resourceIds = null;
                if (agendas) {
                    resourceIds = resources.map(x => selectId(x))
                }

                return $http({
                    method: 'POST',
                    url: url,
                    data: {
                        dagVan: van,
                        dagTot: tot,
                        discipline: discipline,
                        uitgeslotenDagen: uitgeslotenDagen,
                        relationId: relationId,
                        duration: duration,
                        agendas: agendaIds,
                        resources: resourceIds
                    },
                }).then(function (response) {
                    return createSlices(response);
                });
            };

            var downloadAgendaExport = function (url, van, tot, discipline, uitgeslotenDagen) {
                return $http({
                    method: 'GET',
                    url: url,
                    params: {dagVan: van, dagTot: tot, discipline: discipline, uitgeslotenDagen: uitgeslotenDagen},
                    responseType: (url.endsWith("pdf") || url.endsWith("docx")) ? "arraybuffer" : ""
                });
            };

            Agendas.eventsVoorPraktijk = function (praktijkId, dag, discipline, agendas, resources) {
                return haalSlicesOp(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/afspraakmogelijkheden', dag, dag, discipline, agendas, resources, null, appointmentFilter.relationId, appointmentFilter.duration);
            };

            Agendas.agendaExportVoorPraktijk = function (extention, praktijkId, dag, discipline, agendas) {
                return downloadAgendaExport(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/afspraakmogelijkheden/agenda.' + extention, dag, dag, discipline, agendas, resources);
            };

            Agendas.agendaExportVoorAgenda = function (extention, agendaId, van, tot, uitgeslotenDagen) {
                return downloadAgendaExport(AppConfigService.getApiUrl() + agendaId + '/afspraakmogelijkheden/agenda.' + extention, van, tot, null, null, uitgeslotenDagen);
            };

            Agendas.eventsVoorAgenda = function (agendaId, van, tot, uitgeslotenDagen) {
                return haalSlicesOp(AppConfigService.getApiUrl() + agendaId + '/afspraakmogelijkheden', van, tot, null, null, uitgeslotenDagen, appointmentFilter.relationId, appointmentFilter.duration);
            };

            Agendas.verwijderEvents = function (praktijkId, eventIds) {
                return $http({
                    method: 'POST',
                    url: AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/afspraakmogelijkheden/verwijder',
                    data: {ids: eventIds}
                });
            };

            Agendas.wijzigEventType = function (praktijkId, afspraakType, eventIds) {
                return $http({
                    method: 'POST',
                    url: AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/afspraakmogelijkheden/wijzigtype',
                    data: {ids: eventIds, type: afspraakType.id}
                });
            };

            Agendas.setAppointmentType = function (relationId) {
                appointmentFilter.relationId = relationId;
            }

            Agendas.setDuration = function (duration) {
                appointmentFilter.duration = duration;
            }

            return Agendas;
        })
        .factory('Resources', function ($http, AppConfigService, praktijkContext) {
            return {
                getDayAvailability: function (day) {
                    let url = AppConfigService.getApiUrl() + "/api/calendar/v1/party/" + praktijkContext.id + "/resource-details/availabilites/from/" + day + "/until/" + day;
                    return $http.get(url).then(function (response) {
                        return response.data;
                    });
                },
                checkResourceConflict: function (day, from, until, resourceIds, appointmentId) {
                    let url = AppConfigService.getApiUrl() + "/api/calendar/v1/party/" + praktijkContext.id + "/appointment/resource-conflict/check";
                    return $http.post(url, {resources: resourceIds, day: day, from: from, until: until, appointmentId: appointmentId})
                        .then(response => response.data);
                }
            };
        })
        .factory('Legende', function () {
            var Legende = {};
            Legende.soortenAfpsraakMogelijkhedenVoor = function (dagen) {
                return _.chain(dagen)
                    .pluck('events').flatten()
                    .uniq(function (event) {
                        return event.type;
                    })
                    .map(function (event) {
                        return {
                            kleur: event.kleur,
                            type: event.type,
                            typeId: event.typeId
                        };
                    }).value();
            };

            return Legende;
        })
        .factory('BeschikbaarheidTypes', function ($http, AppConfigService) {
            return {
                getTypes: function (praktijkId) {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/typebeschikbaarheid').then(function (response) {
                        var result = response.data;
                        result.findTypeVoorId = function (id) {
                            return _.find(this, function (type) {
                                return type.id === id;
                            });
                        };
                        return result;
                    });
                }
            };
        })
        .factory('Disciplines', function ($http, AppConfigService, praktijkContext) {
            return {
                getList: function () {
                    return $http.get(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/discipline/active')
                        .then(function (response) {
                            return response.data.map(x => {
                                return {
                                    naam: x.name,
                                    id: x.id
                                }
                            });
                        });
                }
            };
        })
        .factory('Rolnames', function ($http, AppConfigService) {
            return {
                getList: function () {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/rolnames')
                        .then(function (response) {
                            return response.data;
                        });
                }
            };
        })
        .factory('AfspraakMogelijkheidTypes', function ($http, AppConfigService) {
            return {
                getTypes: function (praktijkId) {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/typeafspraakmogelijkheid').then(function (response) {
                        var result = response.data;
                        result.findTypeVoorId = function (id) {
                            return _.find(this, function (type) {
                                return type.id === id;
                            });
                        };
                        return result;
                    });
                }
            };
        })
        .factory('RecurrenteAfspraken', function ($http) {
            return {
                getRecurrenteAfspraak: function (agendaId, recurrenteAfspraakId) {
                    return $http.get(agendaId + '/recurrenteafspraak/' + recurrenteAfspraakId).then(function (response) {
                        return response.data;
                    });
                }
            };
        })
        .factory('EventFactory', function ($http, $filter, userContext, AppConfigService, appContext, praktijkContext) {

            function getNewAppointmentUrl() {
                return AppConfigService.getApiUrl() + "/api/calendar/v1/party/" + praktijkContext.id + "/appointment";
            }

            class Event {
                constructor(eventData) {
                    angular.extend(this, eventData);
                    if (typeof AvailabilityReleaseStrategy !== 'undefined') {
                        this.availabilityReleaseStrategy = new AvailabilityReleaseStrategy(eventData.availabilityReleaseStrategy);
                    }
                }

                saveWijzigingen() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/wijziging', this);
                }

                verwijder() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/verwijder', this);
                }

                checkRecurringAppointmentDelete() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/checkrecurringappointmentdelete', this);
                }

                deleteWithNextRecurringAppointments() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/deletewithnextrecurringappointments', this);
                }

                annuleer() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/annuleer', this);
                }

                getPatientTitle() {
                    return this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId);
                }

                getPatientFullTitle() {
                    return this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId);
                }

                getAdminTitle() {
                    return this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId);
                }

                getAdminTooltip() {
                    return this.getAdminFullTitle();
                }

                getAdminFullTitle() {
                    return this.van + ' - ' + this.tot + ' ' + (this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId));
                }

                getMijnAgendaTitle() {
                    return this.van + ' - ' + this.tot + ' ' + (this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId));
                }

                getMijnAgendaFullTitle() {
                    return this.van + ' - ' + this.tot + ' ' + (this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId));
                }

                isVrijgaveDagZelf() {
                    return this.vrijgaveStrategie === 'dagZelf';
                }
            }

            class Afspraak extends Event {
                constructor(eventData) {
                    super(eventData);
                }

                undoVerwijder() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/undo-verwijder', this);
                }

                verberg() {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/verberg', this);
                }

                verplaats(target) {

                    const apppointmentMoveRequest = {
                        calendarId: doclrStaticUtils.getUUIDFromUrl(target.agendaId),
                        day: target.dag,
                        duration: target.duur,
                        from: target.van,
                        until: target.tot
                    }

                    var appointmentId = doclrStaticUtils.getUUIDFromUrl(this.id);

                    return $http.post(getNewAppointmentUrl() + "/" + appointmentId + '/move', apppointmentMoveRequest).then(function (response) {
                        return new Afspraak(response.data);
                    });
                }

                verplaatsCheck(target) {
                    const appointmentMoveRequest = {
                        calendarId: doclrStaticUtils.getUUIDFromUrl(target.agendaId),
                        day: target.dag,
                        duration: target.duur,
                        from: target.van,
                        until: target.tot
                    };
                    var appointmentId = doclrStaticUtils.getUUIDFromUrl(this.id);
                    return $http.post(getNewAppointmentUrl() + '/' + appointmentId + '/move/check', appointmentMoveRequest)
                        .then(response => response.data.conflictingResources);
                }

                kopieer(target) {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/kopieer', target).then(function (response) {
                        return new Afspraak(response.data);
                    });
                }

                zetAanwezig(aanwezig) {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/zet-aanwezig', {aanwezig: aanwezig}).then(function (response) {
                        return new Afspraak(response.data);
                    });
                }

                zetInTreatment(inTreatment) {
                    return $http.post(AppConfigService.getApiUrl() + this.id + '/zet-in-treatment', {inTreatment: inTreatment}).then(function (response) {
                        return new Afspraak(response.data);
                    });
                }

                isGemaaktDoorPatient() {
                    return this.creatieRol === 'patient';
                }

                getAdminTitle() {
                    return this.getFromForAppointment() + this.getNameDisplay() + this.getReasonDisplay();
                }

                getAdminTooltip() {
                    return this.getAdminFullTitle();
                }

                getAdminFullTitle() {
                    return this.getFromToDisplay() + ' ' + this.getNameDisplay() + this.getReasonDisplay() + (this.isVrijgaveDagZelf() ? ' (Afspraak was pas dag zelf beschikbaar voor burger)' : '');
                }

                getMijnAgendaTitle() {
                    return this.getFromToDisplay() + ' ' + this.getNameDisplay() + this.getReasonDisplay();
                }

                getMijnAgendaFullTitle() {
                    return this.getFromToDisplay() + ' ' + this.getNameDisplay() + this.getReasonDisplay() + (this.isVrijgaveDagZelf() ? ' (Afspraak was pas dag zelf beschikbaar voor burger)' : '');
                }

                isVrijgaveZichtbaar() {
                    return true;
                }

                isVrijgaveAanpasbaar() {
                    return false;
                }

                hasExtraReason() {
                    return this.getReasonDisplay().includes(";") || this.getReasonDisplay().includes("•");
                };

                getFromForAppointment() {
                    return userContext.appointmentStarthourVisible ? this.van + ' ' : '';
                }

                getNameDisplay() {
                    if (appContext.brandingSettings.displaySurnameFirst) {
                        return this.naam + (this.voornaam ? ' ' + this.voornaam : '')
                    } else {
                        return (this.voornaam ? this.voornaam + ' ' : '') + this.naam
                    }
                }

                getReasonDisplay() {
                    return (this.reden ? ' (' + this.reden + ')' : '').replaceAll(';', '•');
                }

                getFromToDisplay() {
                    return this.van + ' - ' + this.tot;
                }
            }

            class AfspraakMogelijkheid extends Event {
                constructor(eventData) {
                    super(eventData);
                }

                getPatientTitle() {
                    return this.van + ' ' + (this.bezet ? 'Bezet' : (this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId)));
                }

                getPatientFullTitle() {
                    return this.van + ' ' + (this.bezet ? 'Bezet' : (this.titel || $filter('translateTypeByIdWithTypePrefix')(this.typeId)));
                }

                getAdminTitle() {
                    return this.van;
                }

                getAdminTooltip() {
                    return this.van + ' - ' + this.tot + " " + $filter('translateTypeByIdWithTypePrefix')(this.typeId) + (this.isVrijgaveDagZelf() ? ' (Afspraak pas dag zelf beschikbaar voor burgers)' : '');
                }

                getAdminFullTitle() {
                    return this.van + ' - ' + this.tot + (this.isVrijgaveDagZelf() ? ' (Afspraak pas dag zelf beschikbaar voor burgers)' : '');
                }

                getMijnAgendaTitle() {
                    return this.van + ' - ' + this.tot;
                }

                getMijnAgendaFullTitle() {
                    return this.van + ' - ' + this.tot + (this.isVrijgaveDagZelf() ? ' (Afspraak pas dag zelf beschikbaar voor burgers)' : '');
                }

                maakAfspraak(afspraakGegevens) {

                    return $http.post(AppConfigService.getApiUrl() + this.id, afspraakGegevens, {relationId: afspraakGegevens.relationId}).then(function (response) {
                        return response.data;
                    });
                }

                isVrijgaveAanpasbaar() {
                    return this.metAfspraakmogelijkheden && this.invulbaarDoorPatient;
                }

                hasExtraReason() {
                    return false;
                };

                isVrijgaveZichtbaar() {
                    return this.metAfspraakmogelijkheden && this.invulbaarDoorPatient;
                }
            }

            function createEvent(eventData) {
                if (eventData.eventType === 'afspraak') {
                    return new Afspraak(eventData);
                }
                if (eventData.metAfspraakmogelijkheden) {
                    return new AfspraakMogelijkheid(eventData);
                }
                return new Event(eventData);
            }

            return {createEvent: createEvent};
        })
        .factory('Werkschema', function ($http, AppConfigService) {
            var Werkschema = function (data) {
                angular.extend(this, data);
            };

            Werkschema.load = function (werkschemaId) {
                return $http.get(AppConfigService.getApiUrl() + werkschemaId)
                    .then(function (response) {
                        return new Werkschema(response.data);
                    });
            };

            Werkschema.getLijst = function (praktijkId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/werkschema')
                    .then(function (response) {
                        var werkschemas = response.data;
                        werkschemas.getAgendaById = function (agendaId) {
                            return _.find(this, function (agenda) {
                                return agendaId && agendaId.indexOf(agenda.id) !== -1;
                            });
                        };
                        return werkschemas;
                    });
            };

            Werkschema.prototype.save = function () {
                return $http.post(AppConfigService.getApiUrl() + this.id, JSON.stringify(this)).then(
                    function (response) {
                        return new Werkschema(response.data);
                    }
                );
            };

            Werkschema.prototype.verwijder = function () {
                return $http({
                    method: 'DELETE',
                    url: AppConfigService.getApiUrl() + this.id
                });
            };

            Werkschema.prototype.copy = function (agenda, vanaf) {
                return $http.post(AppConfigService.getApiUrl() + agenda.id + this.id.substring(this.id.indexOf('/werkschema')) + '/copy', {vanaf: vanaf});
            };

            Werkschema.prototype.copyDag = function (dagVan, dagNaar, werkschemaVan, werkschemaNaar) {
                return $http.post(AppConfigService.getApiUrl() + this.id + '/copy-day', {
                    fromWorkScheduleId: werkschemaVan,
                    toWorkScheduleId: werkschemaNaar,
                    week: this.weekIndex,
                    dayCopyFrom: dagVan,
                    dayCopyTo: dagNaar
                });
            };

            Werkschema.prototype.deleteDag = function (dag) {
                return $http.post(AppConfigService.getApiUrl() + this.id + '/delete-day', {
                    week: this.weekIndex,
                    dayToDelete: dag
                });
            };

            return Werkschema;
        })
        .factory('Berichten', function ($http) {
            function getUserHref(userContext) {
                return '/api/user/' + userContext.id;
            }

            function Bericht(data, userContext) {
                angular.extend(this, data);

                this.afgewerkt = _.some(this.status.taak, function (status) {
                    return (status.user.id === getUserHref(userContext) || (status.user.type === 'secretariaat' && userContext.isSecretariaat())) && status.done;
                });
            }

            Bericht.prototype.toggleAfgewerkt = function () {
                return $http.put(this.id + '/done', (!this.afgewerkt).toString());
            };

            Bericht.prototype.verwijderLabel = function (label) {
                return $http({
                    method: 'DELETE',
                    url: this.id + '/labels/' + label
                });
            };

            Bericht.prototype.save = function () {
                return $http.put(this.id, this);
            };

            return {
                zoek: function (userContext, praktijkContext, criteria) {
                    var url = userContext.admin ? '/api/party/' + praktijkContext.id + '/berichten' : getUserHref(userContext) + '/berichten';

                    url = url + '?aantal=' + criteria.aantal;

                    if (criteria.label) {
                        url = url + '&label=' + criteria.label;
                    }
                    if (criteria.type) {
                        url = url + '&type=' + criteria.type;
                    }
                    if (criteria.zoekString) {
                        url = url + '&q=' + criteria.zoekString;
                    }

                    return $http.get(url)
                        .then(function (response) {
                            return {
                                berichten: _.map(response.data.berichten, function (bericht) {
                                    return new Bericht(bericht, userContext);
                                }),
                                overzicht: response.data.overzicht
                            };
                        });
                },
                getAantalTeBekijkenBerichten: function (userContext) {
                    return $http.get(getUserHref(userContext) + '/berichten/overzicht').then(function (response) {
                        return response.data.inbox;
                    });
                },
                maakNieuwBericht: function (userContext, bericht) {
                    return $http.post(getUserHref(userContext) + '/berichten', bericht);
                },
                verwijder: function (bericht) {
                    return $http({
                        method: 'DELETE',
                        url: bericht.id
                    });
                },
                addCommentaar: function (bericht, commentaar) {
                    return $http.post(bericht.id + '/reacties', {bericht: commentaar});
                },
                verwijderCommentaar: function (commentaar) {
                    return $http({
                        method: 'DELETE',
                        url: commentaar.id
                    });
                },
                wijzigCommentaar: function (commentaar) {
                    return $http.put(commentaar.id, commentaar);
                },
                getBericht: function (userContext, id) {
                    return $http.get(id).then(function (response) {
                        return new Bericht(response.data, userContext);
                    });
                }
            };
        })
        .factory('AuditEvents', function ($http, EventFactory, AppConfigService, praktijkContext, appContext) {
            const AuditEvents = {};

            AuditEvents.getForEntityId = function (id) {
                return $http.get(AppConfigService.getApiUrl() + '/api/audit/v1/party/' + praktijkContext.id + '/audit-events/entity/' + id)
                    .then(function (response) {
                        return response.data;
                    });
            };

            return AuditEvents;
        })
        .factory('Afspraken', function ($http, EventFactory, AppConfigService, praktijkContext, appContext) {
            var Afspraken = {};

            Afspraken.getAfspraak = function (id) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkContext.id + '/afspraak/' + id).then(function (response) {
                    return EventFactory.createEvent(response.data);
                });
            };

            // DOCLEAS-042: colleague / resource participant rows of an appointment
            Afspraken.getParticipants = function (appointmentId) {
                return $http.get(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/appointment/' + appointmentId + '/participants')
                    .then(response => response.data);
            };

            Afspraken.updateParticipants = function (appointmentId, participants) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkContext.id + '/afspraak/' + appointmentId + '/participants', participants);
            };

            Afspraken.changeOwner = function (appointmentId, newOwnerAppointmentId) {
                return $http.post(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/appointment/' + appointmentId + '/change-owner/' + newOwnerAppointmentId);
            };

            Afspraken.zoeken = function (zoekString, praktijkId) {
                return $http({
                    method: 'POST',
                    url: AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkId + '/appointment/back-office/search',
                    data: zoekString
                })
                    .then(function (response) {
                        return response.data;
                    }).then(function (appointments) {
                        return angular.forEach(appointments, function (appointment) {
                            const van = moment(appointment.from, 'HH:mm');
                            if (appointment.birthDate) {
                                appointment.age = moment().diff(appointment.birthDate, 'years', false);
                            }
                            appointment.displaySurnameFirst = appContext.brandingSettings.displaySurnameFirst;
                            appointment.tijdstip = moment(appointment.day).hour(van.hours()).minute(van.minutes()).toDate();
                        });
                    });
            };

            return Afspraken;
        })
        .factory('Absences', function ($http, EventFactory, AppConfigService, praktijkContext) {
            var Absences = {};

            Absences.getAbsence = function (calendarId, id, isPartyAbsence) {
                if (isPartyAbsence) {
                    return $http.get(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/party-absence/' + id)
                        .then(function (response) {
                            var data = response.data;
                            data.isPartyAbsence = true;
                            return data;
                        });
                }

                return $http.get(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/calendar/' + calendarId + '/calendar-absence/' + id)
                    .then(function (response) {
                        const calendarAbsence = response.data;
                        calendarAbsence.calendarId = calendarId;
                        calendarAbsence.calendarIds = [calendarId];
                        calendarAbsence.forAllCalendars = false;
                        calendarAbsence.isPartyAbsence = false;
                        return calendarAbsence;
                    });
            };

            Absences.deletePartyAbsence = function (id) {
                return $http.delete(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/party-absence/' + id)
            }

            Absences.updateAbsence = function (id, calendarId, absence, isPartyAbsence) {
                if (isPartyAbsence) {
                    absence.partyId = praktijkContext.id;
                    absence.id = id;

                    return $http.put(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/party-absence/' + id, absence)
                } else {
                    return $http.put(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/calendar/' + calendarId + '/calendar-absence/' + id, absence);
                }
            }

            return Absences;
        })
        .factory('Patienten', function ($http, AppConfigService) {
            var Patienten = {};

            Patienten.getList = function (praktijkId, status, zoek, page) {

                var query = {page: page};
                if (status !== 'AlleStatussen') {
                    query.status = status;
                }

                if (zoek) {
                    query.zoek = zoek;
                }

                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/patienten/list', {params: query})
                    .then(function (response) {
                        return response.data;
                    });
            };

            Patienten.getPatientInfo = function (praktijkId, patientId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/patienten/' + patientId + '/info')
                    .then(function (response) {
                        return response.data;
                    });
            };

            Patienten.getPatientGegevens = function (praktijkId, patientId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/patienten/' + patientId)
                    .then(function (response) {
                        return response.data;
                    });
            };

            Patienten.updatePatientGegevens = function (praktijkId, patientGegevens) {
                return $http.put(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/patienten/' + patientGegevens.id, patientGegevens);
            };

            Patienten.updateStatus = function (praktijkId, patientId, status) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/patienten/' + patientId + '/status', {status: status})
                    .then(function (response) {
                        return response.data;
                    });
            };

            return Patienten;
        })
        .factory('Users', function ($http, AppConfigService) {
            var Users = {};

            Users.getList = function (praktijkId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/user/list/' + praktijkId)
                    .then(function (response) {
                        return response.data;
                    });
            };

            Users.nieuweUser = function (praktijkId, email, voornaam, naam, rolnaam) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/user/add/' + praktijkId, {
                    email: email,
                    voornaam: voornaam,
                    naam: naam,
                    rolnaam: rolnaam,
                    defaultPraktijkId: praktijkId
                });
            };

            Users.ontzegToegangPraktijk = function (user) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + user.praktijkId + '/user/' + user.id.replace('/api/user/', '') + '/ontzeg-toegang-praktijk', {});
            };

            Users.getToken = function (userId, praktijkId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/user/' + userId + '/token')
                    .then(function (response) {
                        return response.data;
                    });
            };

            Users.wijzigPraktijk = function (praktijkId) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/user/wijzigpraktijk/' + praktijkId);
            };

            Users.getPraktijken = function () {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/user/praktijken')
                    .then(function (response) {
                        return response.data;
                    });
            };

            Users.maakToken = function (userId, praktijkId) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/user/' + userId + '/token', {});
            };

            Users.maakAangepastToken = function (userId, token, praktijkId) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/user/' + userId + '/aangepastToken', {token: token});
            };

            Users.verwijderToken = function (userId, praktijkId) {
                return $http.delete(AppConfigService.getApiUrl() + '/api/party/' + praktijkId + '/user/' + userId + '/token', {});
            };

            Users.save = function (userContext) {
                return $http.post(AppConfigService.getApiUrl() + '/api/user/gegevens', userContext);
            };

            return Users;
        })
        .factory('Praktijk', function ($http, AppConfigService, praktijkContext) {
            return {
                getInfo: function (praktijkId) {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId)
                        .then(function (response) {
                            return response.data;
                        });
                },

                listTypeBeschikbaarheidVoorAdres: function (praktijkId, adresId) {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/adres/' + adresId + '/typebeschikbaarheid')
                        .then(function (response) {
                            return response.data;
                        });
                },

                getICalendarUri: function (agendaId) {
                    return $http.get(AppConfigService.getApiUrl() + agendaId + '/private-icalendar-url')
                        .then(function (response) {
                            return response.data;
                        });
                },

                wijzigAgenda: function (agenda) {

                    const calendarToUpdate = Object.assign({}, agenda);
                    calendarToUpdate.id = calendarToUpdate.uuid;
                    return $http.post(AppConfigService.getApiUrl() + agenda.id + '/wijziging', calendarToUpdate)
                        .then(function (response) {
                            return response.data;
                        });
                },

                wijzigPraktijk: function (praktijk) {
                    return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkContext.id + '/wijziging', praktijk)
                        .then(function (response) {
                            return response.data;
                        });
                },

                verwijderPraktijk: function (praktijkId) {
                    return $http({
                        method: 'DELETE',
                        url: AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId
                    });
                },

                createPraktijk: function (praktijk) {
                    return $http.post(AppConfigService.getApiUrl() + '/apiv0/party', praktijk)
                        .then(function (response) {
                            return response.data;
                        });
                },

                getList: function () {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party')
                        .then(function (response) {
                            return response.data;
                        });
                },

                zoekPatientOpNaam: function (zoekString) {
                    var params = {
                        zoekString: zoekString,
                        limiet: 10
                    };
                    return $http({
                        method: 'GET',
                        url: AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkContext.id + '/patienten/zoeken-naam',
                        params: params
                    })
                        .then(function (response) {
                            return response.data;
                        });
                },

                zoekPatientOpGeboortedatum: function (zoekGeboortedatum) {
                    //'zoekGeboortedatum = 'DD-MM-YYYY'
                    var date = moment(zoekGeboortedatum, 'DD-MM-YYYY');
                    var valid = date.isValid() && date.isAfter(moment('1850', 'YYYY'));
                    if (!valid || !zoekGeboortedatum || zoekGeboortedatum.length < 10) {
                        return [];
                    }

                    var params = {
                        zoekGeboortedatum: date.format('YYYY-MM-DD'),
                        limiet: 10
                    };
                    return $http({
                        method: 'GET',
                        url: AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkContext.id + '/patienten/zoeken-geboortedatum',
                        params: params
                    })
                        .then(function (response) {
                            return response.data;
                        });
                }
            };
        })
        .factory('Statistieken', function ($http, AppConfigService) {
            var Statistieken = {};

            Statistieken.getPeriode = function (praktijkId, form) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/statistieken/' + praktijkId, {params: form})
                    .then(function (response) {
                        _.each(response.data.data, function (aantallen) {
                            aantallen.dag = moment(aantallen.periode).toDate();
                        });
                        return response.data;
                    });
            };

            return Statistieken;
        })
        .factory('EditableBeschikbaarheidTypes', function ($http, AppConfigService) {
            var EditableBeschikbaarheidTypes = {};

            EditableBeschikbaarheidTypes.getList = function (praktijkId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/typebeschikbaarheid/editable')
                    .then(function (response) {
                        return response.data;
                    });
            };

            EditableBeschikbaarheidTypes.load = function (typeId) {
                return $http.get(AppConfigService.getApiUrl() + typeId)
                    .then(function (response) {
                        return response.data;
                    });
            };

            EditableBeschikbaarheidTypes.saveWijzigingen = function (type) {
                return $http.post(AppConfigService.getApiUrl() + type.id, type);
            };

            EditableBeschikbaarheidTypes.saveTranslationItem = function (type, language, text, translationKey) {
                if (translationKey === 'mailText') {
                    return $http.post(AppConfigService.getApiUrl() + type.id + "/mailtext", {
                        language: language,
                        text: text
                    });
                } else {
                    return $http.post(AppConfigService.getApiUrl() + type.id + "/extra-html", {
                        language: language,
                        text: text
                    });
                }
            };

            EditableBeschikbaarheidTypes.setDefault = function (praktijkId, typeId) {
                return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + "/typebeschikbaarheid/" + typeId.split('/').pop() + "/set-default");
            };

            EditableBeschikbaarheidTypes.getMailOntvangers = function (typeId, praktijkId) {
                if (typeId) {
                    return $http.get(AppConfigService.getApiUrl() + typeId + '/mailontvangers')
                        .then(function (response) {
                            return response.data;
                        });
                }
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/typebeschikbaarheid/mailontvangers')
                    .then(function (response) {
                        return response.data;
                    });
            };

            EditableBeschikbaarheidTypes.saveNieuwType = function (praktijkId, type) {
                return $http
                    .post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/typebeschikbaarheid', type)
                    .then(function (response) {
                        return response.data;
                    });
            };

            EditableBeschikbaarheidTypes.verwijder = function (type) {
                return $http({
                    method: 'DELETE',
                    url: AppConfigService.getApiUrl() + type.id
                });
            };

            return EditableBeschikbaarheidTypes;
        })
        .factory('RichtlijnenTelesecretariaat', function ($http, AppConfigService) {
            return {
                getInfo: function (praktijkId, agendaId) {
                    return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/agenda/' + agendaId + '/tele/')
                        .then(function (response) {
                            return response.data;
                        });
                },
                wijzigRichtlijnen: function (praktijkId, agendaId, richtlijnenInfo) {
                    return $http.post(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/agenda/' + agendaId + '/tele/wijziging', richtlijnenInfo)
                        .then(function (response) {
                            return response.data;
                        });
                }
            };
        })
        .factory('IpdcProducten', function ($http, AppConfigService) {
            const ipdcProducten = {};
            ipdcProducten.getList = function (praktijkId) {
                return $http.get(AppConfigService.getApiUrl() + '/apiv0/party/' + praktijkId + '/ipdcproduct')
                    .then(function (response) {
                        return response.data;
                    });
            };
            return ipdcProducten;
        })
        .factory('UserProfileService', ['$http', 'AppConfigService', 'appContext', 'praktijkContext',
            function ($http, AppConfigService, appContext, praktijkContext) {
                const getSavedViews = () =>
                    (appContext.user && appContext.user.profile && appContext.user.profile.viewState)
                        ? (appContext.user.profile.viewState.savedViews || [])
                        : [];

                function persist(views) {
                    if (appContext.user && appContext.user.profile && appContext.user.profile.viewState) {
                        appContext.user.profile.viewState.savedViews = views;
                    }
                    return $http.put(
                        AppConfigService.getApiUrl() + '/api/user/v1/party/' + praktijkContext.id + '/profile/saved-calendar-views',
                        views
                    ).then(response => {
                        if (appContext.user) {
                            appContext.user.profile = response.data;
                        }
                    });
                }

                return {
                    getSavedViews: getSavedViews,
                    addView: (name, calendarIds, resourceIds, collapsedGroupTitles) => persist([...getSavedViews(), {name: name, calendarIds: calendarIds, resourceIds: resourceIds || [], collapsedGroupTitles: collapsedGroupTitles || []}]),
                    updateView: (index, calendarIds, resourceIds, collapsedGroupTitles) => persist(getSavedViews().map((v, i) => i === index ? {name: v.name, calendarIds: calendarIds, resourceIds: resourceIds || [], collapsedGroupTitles: collapsedGroupTitles || []} : v)),
                    renameView: (index, newName) => persist(getSavedViews().map((v, i) => i === index ? {name: newName, calendarIds: v.calendarIds, resourceIds: v.resourceIds || [], collapsedGroupTitles: v.collapsedGroupTitles || []} : v)),
                    deleteView: (index) => persist(getSavedViews().filter((v, i) => i !== index))
                };
            }]);

})();